import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

// 
import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map} from 'rxjs';
import { Subscription } from 'rxjs';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { SubjectContactEmail } from './../../../shared/models/jobSubjectContactEmail.model';

@Component({
  selector: 'app-subject-contact-email-edit-widget',
  templateUrl: './subject-contact-email-edit-widget.component.html',
  styleUrls: ['./subject-contact-email-edit-widget.component.css']
})
export class SubjectContactEmailEditWidgetComponent implements OnInit {


   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full

   job: Object;
   job_id;

   @Input() intialCount? = 221;
   @Input() count? = this.intialCount;
   @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();

   model: SubjectContactEmail;
 job_plaintiff_types: any;
  subject_id: any;
  subject_id2: any;

  subject_contact_email: any;

  @Input() subject_contact_email_id?: any;

 constructor(
   private http: HttpClient, private _demoService: DemoService,
   private route: ActivatedRoute,
    vcr: ViewContainerRef, private router: Router,
    public HttpClient:HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService
 ) { }

 // check for changes. to load data.
 ngOnChanges(changes) {

   this.model = new SubjectContactEmail();
  /// this.getJobPlaintiffTypes();
   if (changes.item_id) {
     // deal with asynchronous Observable result
   this.subject_id = changes.item_id.currentValue.value;
    // this.model.subject_contact_email_id = this.subject_contact_email_id;
     // this.getJob(this.job_id);
     
     this.getSubjectContactEmail(this.subject_contact_email_id);

   }
 }


 ngOnInit() {
 }

 // Functions


 getSubjectContactEmail(subject_contact_email_id) {
  this._demoService.getSubjectContactEmail(subject_contact_email_id).subscribe(
     data => { this.subject_contact_email = data;
      let res = data[0];
      // Run the job data queries.
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 editSubjectContactEmail(model) {
  //model.subject_id = this.subject_id;
 this._demoService.editSubjectContactEmail(model).subscribe(
   data => { 
    //  this.toastr.info('Subject Contact Email Updated');
     this.closeParentModel.emit();
   },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );

}



 addSubjectContactEmail(model) {
   //model.subject_id = this.subject_id;
  this._demoService.createSubjectContactEmail(model).subscribe(
    data => { 
      // this.toastr.info('Subject Contact Email Added');
      this.closeParentModel.emit();
    },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );

 }



 getJob(job_id) {
 this._demoService.getJobID(job_id).subscribe(
    data => { this.job = data;
     let res = data[0];
     // Run the job data queries.
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

addJobPlaintiff(model) {
 this._demoService.addJobPlaintiff(model).subscribe(
   data => { },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );
//  this.toastr.info('Plaintiff & Type Added');
 this.closeParentModel.emit();
}





getJobPlaintiffTypes() {
 this._demoService.getJobPlaintiffTypes().subscribe(
    data => { this.job_plaintiff_types = data; },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


}
